// extracted by mini-css-extract-plugin
export default {"flourCount":"FlourCount_flourCount__0zOz3"};